module.exports = __webpack_public_path__ + "static/media/visitors.5af102a8.svg";